<!--
 * @Description: 子表单
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <jw-space direction="vertical" class="ly-form-table-space">
    <!-- 子表单列表 -->
    <sub-form-table :isCanEdit="isCanEdit" :modulesItem="modulesItem" :allModules="formatAllModules" :mainForm="mainForm" :from="from" :type="type" :entity="entity" :dataList="data.detailDataList" isfull="0" @cb="openScreen" />
  </jw-space>
  <!-- 全屏状态 -->
  <jw-drawer class="ly-sub-form-screen" width="100%" :header="false" :footer="false" :visible="data.fullVisible" unmountOnClose ref="subFormScreen">
    <!-- 子表单列表 -->
    <sub-form-table :isCanEdit="isCanEdit" :modulesItem="modulesItem" :allModules="formatAllModules" :mainForm="mainForm" :from="from" :type="type" :entity="entity" :dataList="data.detailDataList" isfull="1" @cb="openScreen" />
  </jw-drawer>
</template>

<script setup>
import { computed, reactive, ref, nextTick, onMounted, inject, watch } from 'vue';
// import { useI18n } from 'vue-i18n';
import SubFormTable from '@/components/layout/ly-sub-form/components/sub-form-table/index.vue';
// const { t } = useI18n();
import useViewFields from '@/hooks/view-fields';
import { useRoute } from 'vue-router';
const route = useRoute();
const { setEditFormTable } = useViewFields();
import _ from 'lodash';
// const emit = defineEmits(['cb']);
import { tools } from '@/utils/tools';
const props = defineProps({
  modules: {
    //规则过滤过得表格的字段信息
    type: Object,
    default: () => {}
  },
  allModules: {
    //全部表格的字段信息
    type: Object,
    default: () => {}
  },
  //30:新增 40：编辑
  type: {
    type: Number || String,
    default: null
  },
  copy: {
    //1：复制
    type: Number,
    default: null
  },
  entity: {
    type: Number || String,
    default: null
  },
  viewId: {
    type: Number || String,
    default: null
  },
  id: {
    //这条主数据的ID(只有编辑时有)
    type: Number || String,
    default: ''
  },
  from: {
    //来源
    // 20 是基本信息  30 是关联表格
    type: Number || String,
    default: () => 20
  },
  optype: {
    //操作类型
    // 0 新增  1 编辑/复制
    type: Number || String,
    default: () => 0
  },
  setDataList: {
    //表格数据
    type: Array,
    default: () => []
  },
  mainForm: {
    //主表数据
    type: Array,
    default: () => []
  },
  isAssociated: {
    type: Boolean,
    default: false
  },
  isCanEdit: {
    //规则是否可编辑
    type: Boolean,
    default: true
  }
});
const isDoneFirst = inject('globalFormData')?.isDoneFirst;
const _modules = computed(() => {
  return _.cloneDeep(props.modules?.modules?.filter((v) => v.value != props.modules?.associateKey && v.type != 40));
});
const formatAllModules = ref(_.cloneDeep(props.allModules));
//监听匹配规则导致的子表单字段更新
watch(
  () => _modules.value,
  () => {
    modulesItem.value.modules = _modules.value;
    nextTick(() => {
      if (isDoneFirst?.value) formatAllModulesField(_modules.value);
    });
  },
  { deep: true }
);
watch(
  () => props.modules,
  () => {
    const isJsonPermission = tools.isJSON(modulesItem.value?.permission);
    modulesItem.value = _.cloneDeep(props.modules);
    //2025年06月16日18:24:10 zl如果是是json字符串则赋值则直接取props.modules结构中，不是json字符串说明已经转过json对象了，则判断是否是json字符串，是的话直接转json对象赋值
    if (!isJsonPermission) {
      modulesItem.value.permission = props.modules?.permission && tools.isJSON(props.modules?.permission) ? JSON.parse(props.modules?.permission) : {};
    }
    modulesItem.value.modules = _modules.value;
  }
);
const formatAllModulesField = (m) => {
  //每次modules更新时，可能必填、只读、隐藏属性变更，同步更新所有字段内部的
  formatAllModules.value?.modules?.map((fam) => {
    const _findIndex = m?.findIndex((v) => v.value == fam.value);
    if (_findIndex > -1) {
      fam.businessData = m?.[_findIndex]?.businessData ?? 1;
      fam.display = m?.[_findIndex]?.display ?? 1;
      fam.isRequired = m?.[_findIndex]?.isRequired ?? 0;
    } else {
      fam.businessData = 1;
      fam.display = 0;
      fam.isRequired = 0;
    }
  });
};
const modulesItem = ref(_.cloneDeep(props.modules));
modulesItem.value.modules = _modules.value;
const data = reactive({
  type: computed(() => props.type || route.params?.type), //30: 新增 40：修改
  copy: computed(() => props.copy || route.params?.copy), //对象type
  detailDataList: [], //表格数据
  fullVisible: false //是否全屏状态
});
const { setCallbackData } = inject('methods'); //父组件方法--同步数据给父组件
//子表回调同步更新到主表里
const callbackData = (callbackData) => {
  setCallbackData({
    id: modulesItem.value.id,
    modules: _.cloneDeep(callbackData)
  });
};
// 格式化数据
const setDetailDataList = (modules, records) => {
  data.detailDataList = setEditFormTable(modules, records);
};
//初始化编辑数据到modules
const setEditTableData = () => {
  if (!isDoneFirst?.value) {
    setTimeout(() => {
      setEditTableData();
    }, 100);
    return false;
  }
  if (_modules.value) {
    //子表单(35)
    modulesItem.value.permission = tools.isJSON(modulesItem.value?.permission) ? JSON.parse(modulesItem.value?.permission) : {};
    //2025年03月03日16:02:48添加isAssociated判断，从关联对象表格过来的都需要走赋值逻辑（因为没有落库数据编辑走的是添加，但是需要反显数据）
    // 常用变量
    const { modules, permission, fieldValue } = modulesItem.value || {};
    const { records } = fieldValue || {};
    const { from, isAssociated, optype, setDataList } = props;
    const { type, copy } = data;

    // if (props.from == 20 && (data.type == 40 || data.copy == 1 || props.isAssociated)) {
    //   if (data.type == 40) {
    //     modulesItem.value?.modules?.forEach((item) => {
    //       if (item.businessData == '1' && modulesItem.value?.permission?.canEdit == 1 && modulesItem.value?.permission?.detail?.edit == 1) {
    //         item.businessData = '1';
    //       } else {
    //         item.businessData = '0';
    //       }
    //     });
    //   }
    //   nextTick(() => {
    //     formatAllModulesField(modulesItem.value?.modules);
    //   });
    //   //编辑或复制//基本信息中的子表
    //   data.detailDataList = setEditFormTable(modulesItem.value?.modules, modulesItem.value?.fieldValue?.records);
    // }
    // if (props.from == 20 && data.type == 30 && data.copy != 1) {
    //   //新建时有自定义默认值
    //   data.detailDataList = setEditFormTable(modulesItem.value?.modules, modulesItem.value?.fieldValue?.records);
    // }

    if (from == 20) {
      //主表数据

      // 处理 type == 40 的特殊逻辑
      if (type == 40 && modules) {
        modules.forEach((item) => {
          const canEdit = permission?.canEdit == 1 && permission?.detail?.edit == 1;
          item.businessData = canEdit && item.businessData == '1' ? '1' : '0';
        });
      }
      if (type == 40 || copy == 1 || isAssociated) {
        //来源：编辑，复制，关联对象表格
        nextTick(() => {
          formatAllModulesField(modules);
        });
      }
      if (records?.length > 0) setDetailDataList(modules, records);
    }

    if (optype == 1) {
      //关联对象表格且是编辑或者复制
      data.detailDataList = setDataList || [];
    }
    nextTick(() => {
      callbackData(data.detailDataList);
    });
  }
};
onMounted(() => {
  setEditTableData();
});

// 打开全屏状态
const openScreen = () => {
  data.fullVisible = !data.fullVisible;
};
// 更新子表单数据
const updateRecord = (getRecord) => {
  data.detailDataList = [];

  if (getRecord?.length > 0) data.detailDataList = setEditFormTable(modulesItem.value?.modules, getRecord);

  //   data.isRefresh = false;
  //   nextTick(() => {
  //     data.isRefresh = true;
  //   });
  callbackData(data.detailDataList);
};
defineExpose({
  updateRecord
});
</script>
<style scoped lang="less">
@import './ly-sub-form.less';
</style>
